

import React from 'react'
import '../../styles/hero.css'

import heroDarkImg from '../../images/hero-img.png'
import lightImg from '../../images/light-hero-bg.jpg'

const Hero = (theme) => {
    return (
    <section  className='hero_section'  id="home">
        <div className="container">
            <div className="hero_wrapper">
               <div className="hero_content"></div>
               <div><h2>Home of advertisement</h2> 
               <h2>Bringing customers to your </h2>
                 <h2 className="highlight">door step</h2>
                 </div> 
                 <p className="description"></p>

                 <div className="hero_btns">
                   <button className="primary_btn"><a href="https://instagram.com/brandstorm_marketing?igshid=YmMyMTA2M2Y">Get Started Now</a></button>
                    <button className="secondary_btn"><a href="#services">Discover</a> More</button> 
                 </div>
            </div>

            <div className="hero_img">
                <img src={ theme==='light-theme' ? lightImg : heroDarkImg} alt="hero-img" />
            </div>
        </div>
    </section>
    )
}

export default Hero